<template>
    <el-dialog
    title="菜单目录"
    :visible.sync="centerDialogVisible"
    @close="cancel"
  >
    <div style="margin-bottom:22px">
      <span class="title">类型</span>
      <el-radio-group v-model="choose" @change="radioChange">
        <el-radio :label="3" :disabled="clickType==1&&choose!=3">导航</el-radio>
        <el-radio :label="4" :disabled="clickType==1&&choose!=4">菜单</el-radio>
        <el-radio :label="5" :disabled="clickType==1&&choose!=5">首页</el-radio>
      </el-radio-group>
    </div>
    <el-form ref="submitData" :model="submitData" label-width="120px" :rules="rules">
      <el-form-item label="选择子系统" prop="code">
        <span>{{ sysName }}</span>
      </el-form-item>
      <el-form-item v-if="choose=='3'" label="导航名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>
      <el-form-item v-if="choose=='4'" label="父节点" prop="parentId">
        <span>{{ navName }}</span>
      </el-form-item>
      <el-form-item v-if="choose=='4'" label="菜单名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>

      <el-form-item v-if="choose=='5'" label="首页名称" prop="name">
        <el-input v-model="submitData.name" />
      </el-form-item>
      <el-form-item label="排序号" prop="sort">
        <el-input v-model="submitData.sort" />
      </el-form-item>
      <el-form-item label="path" prop="path">
        <el-input v-model="submitData.path" />
      </el-form-item>
      <el-form-item label="访问地址" prop="url">
        <el-input v-model="submitData.url" />
      </el-form-item>
      <el-form-item label="icon" prop="icon">
        <el-input v-model="submitData.icon" />
      </el-form-item>
    </el-form>
    <span
    slot="footer"
    class="dialog-footer"
  >
  <el-button @click="cancel" style="margin-right:8px">取消</el-button>
  <el-button type="primary" @click="onSubmit('submitData')">确认</el-button>
  </span>
</el-dialog>
</template>
<script>
import { getSystem, createMenu, permissionsList, menuDetail, systemDetail } from '@/api/system'
import { validateLength, lengthFifty, lengthTen, validateTenNumber,validateTwenty } from '@/api/validate'
import Setting from '@/settings'
const {
  apiDomain
} = Setting
import jq from 'jquery'
export default {
  // props:{
  //   menuId:{},
  //   appId:{
  //     default:0
  //   },
  //   parentId:{},
  //   clickType:{},
  //   navName:{}
  // },
  props: ['menuId', 'appid', 'parentId', 'clickType','navName'],
  data() {
    return {
      submitData: {
        appId: this.appid,
        name: '',
        sort: '',
        path: '',
        icon: '',
        url: '',
        id: this.menuId
      },
      centerDialogVisible:true,
      menuIds:this.menuId,
      appId:this.appid,
      rules: {
        name: [{
          required: true,
          validator: validateTwenty,
          trigger: 'change'
        }],
        sort: [{
          required: true,
          validator: validateTenNumber,
          trigger: 'change'
        }],
        path: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }],
        url: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }],
        icon: [{
          required: true,
          validator: lengthFifty,
          trigger: 'change'
        }]

      },
      systemList: [],
      choose: 3,
      data: [],
      list: null,
      sysName: null
    }
  },
  mounted() {
    console.log(JSON.stringify(this.appId));
    console.log(JSON.stringify(this.menuIds));
    this.getSystemDetail()
    this.getMenuDetail(this.menuIds)
    // if (this.parentId == 0) {
    //   this.getMenuDetail(this.menuIds)
    // } else {
    //   this.getMenuDetail(this.menuIds)
    // } 
   
   
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          createMenu(this.submitData).then(res => {
            if (res && res.code === 0) {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.$emit('returnResult',this.submitData.appId)
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    cancel() {
      this.$emit('returnResult',null)
    },
    radioChange() {

    },
    handleNodeClick(data, node, self) {
    },
    getMenuDetail(data, code) {
      const _this=this
      menuDetail({
        id: data
      }).then(res => {
        if (res && res.code == 0) {
            try {
              this.submitData.name = res.data.name
            this.submitData.sort = res.data.sort.toString()
            this.submitData.path = res.data.path
            this.submitData.url = res.data.url
            this.submitData.icon = res.data.icon
            this.choose = res.data.menuType
            } catch (error) {
            }
        }
      })
    },
    getSystemDetail() {
      systemDetail({
        id: this.appId
      }).then(res => {
        if (res && res.code == 0) {
          this.sysName = res.data.name
        }
      })
    },
    


  }
}
</script>
<style lang="scss" scoped>
.title {
  width: 120px;
  text-align: right;
  font-size: 14px;
  padding-right: 13px;
  display: inline-block;
}
.el-radio {
  font-size: 14px !important;
  margin-right: 50px;
}
.el-tree{
  font-size:12px;
}
.file{
  width:16px;
  height: 16px;
  display: inline-block;
  background-size: contain;
  background-image: url("../../../../assets/icon.png");
  margin-right:8px;
}
</style>
